import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BatteryFull, Signal, Wifi } from 'lucide-react';
interface PhoneFrameProps {
  children: React.ReactNode;
  dark?: boolean;
  toast?: string | null;
}
export function PhoneFrame({
  children,
  dark,
  toast
}: PhoneFrameProps) {
  return <div className="relative h-[812px] w-[390px] shrink-0 rounded-[48px] border-[11px] border-slate-900 bg-slate-900 shadow-2xl" data-id="element-796" data-mp="1x5zej18zuspl">
      <div className="relative flex h-full w-full flex-col overflow-hidden rounded-[38px] bg-white" data-id="element-797" data-mp="2aw2wvh4r629r">
        <div className={`relative z-30 flex h-9 shrink-0 items-center justify-between px-6 text-[12px] font-semibold ${dark ? 'bg-black text-white' : 'bg-navy-800 text-white'}`} data-id="element-798" data-mp="26vj38nje1gsd">
          <span data-id="element-799" data-mp="2fy210t8bh37r">১০:২৪</span>
          <span className="absolute left-1/2 top-1.5 h-6 w-24 -translate-x-1/2 rounded-full bg-black" aria-hidden data-id="element-800" data-mp="2fxjyjev29sre" />
          <span className="flex items-center gap-1" data-id="element-801" data-mp="qjne8eguzqew">
            <Signal className="h-3.5 w-3.5" data-id="element-802" data-mp="lk12yaklck8q" />
            <Wifi className="h-3.5 w-3.5" data-id="element-803" data-mp="ll2c29i1qwnt" />
            <BatteryFull className="h-4 w-4" data-id="element-804" data-mp="n2axmmx9sqd" />
          </span>
        </div>
        <div className="relative min-h-0 flex-1" data-id="element-805" data-mp="5kklfhgl8g0h">{children}</div>
        <AnimatePresence data-id="element-806" data-mp="5izstxdu3759">
          {toast && <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: 10
        }} className="absolute bottom-24 left-4 right-4 z-40 rounded-lg bg-navy-900 px-4 py-2.5 text-center text-xs font-medium text-white shadow-lg" role="status" data-id="element-807" data-mp="9mfoaqe631gd">
              {toast}
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}